if (!window.Eurus.loadedScript.has('product-media.js')) {
  window.Eurus.loadedScript.add('product-media.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xProductMedia', (settings) => ({
        thumbnailOnMouseDown: false,
        thumbnailOfset: 0,
        thumbnailScrollOfset: 0,
        thumbnailGrabbingClass: '',
        zoomIsOpen: false,
        productMediaIsOpen: '',
        currentMobileIndex: 1,
        zoomCurrentIndex: 1,
        zoomTouchStartX: 0,
        showPinchHint: true,
        videoExternalListened: false,
        xPosition: 0,
        yPosition: 0,
        imageWidth: 0,
        imageHeight: 0,
        startZoom(event) {
          const elem = event.currentTarget;
          const size = elem.getBoundingClientRect();
          this.xOffset = size.left;
          this.yOffset = size.top;
          this.imageWidth = size.width;
          this.imageHeight = size.height;
        },
        updatePosition(event) {
          if (this.imageWidth && this.imageHeight) {
            this.xPosition = ((event.clientX - this.xOffset) / this.imageWidth) * 100;
            this.yPosition = ((event.clientY - this.yOffset)  / this.imageHeight) * 100;
          }
        },
        thumbnailHandleMouseDown(e) {
          this.thumbnailOnMouseDown = true;
          this.thumbnailGrabbingClass = 'cursor-grabbing';
          if (settings.thumbnail_direction == 'horizontal') {
            this.thumbnailOfset = e.pageX - this.$refs.thumbnail.offsetLeft;
            this.thumbnailScrollOfset = this.$refs.thumbnail.scrollLeft;
          } else {
            this.thumbnailOfset = e.pageY - this.$refs.thumbnail.offsetTop;
            this.thumbnailScrollOfset = this.$refs.thumbnail.scrollTop;
          }
        },
        thumbnailHandleMouseMove(e) {
          if(!this.thumbnailOnMouseDown) return;
          e.preventDefault();
          if (settings.thumbnail_direction == 'horizontal') {
            const x = e.pageX - this.$refs.thumbnail.offsetLeft;
            const walk = (x - this.thumbnailOfset) * 2; 
            this.$refs.thumbnail.scrollLeft = this.thumbnailScrollOfset - walk;
          }
          else {
            const y = e.pageY - this.$refs.thumbnail.offsetTop;
            const walk = (y - this.thumbnailOfset) * 2; 
            this.$refs.thumbnail.scrollTop = this.thumbnailScrollOfset - walk;
          }
        },
        thumbnailHandleMouseLeave() {
          this._thumbnailRemoveGrabing();
        },
        thumbnailHandleMouseUp() {
          this._thumbnailRemoveGrabing();
        },
        _thumbnailRemoveGrabing() {
          this.thumbnailOnMouseDown = false;
          this.thumbnailGrabbingClass = 'md:cursor-grab';
        },
        zoomTotalSlides() {
          const slides = document.querySelectorAll(`#ProductModal-${settings.section_id} .splide__slide, #media-gallery-${settings.section_id} .splide__slide`);
          return slides.length || 1;
        },
        initZoomSplide(splideEl) {
          if (!splideEl) return;
          if (splideEl.splide) {
            splideEl.splide.refresh();
            return;
          }
          if (typeof Splide === 'undefined') return;

          try {
            const splideInstance = new Splide(splideEl, {
              speed: 400,
              pagination: false,
              arrows: false,
              perPage: 1,
              perMove: 1,
              updateOnMove: true,
              direction: settings.is_rtl ? 'rtl' : 'ltr'
            });

            splideInstance.on('move', (newIndex) => {
              const idx = newIndex + 1;
              this.zoomCurrentIndex = idx;
              this.updateZoomCounter(idx);
              this.updateZoomThumbnail(idx);
              document.dispatchEvent(new CustomEvent(`eurus:zoom-slide-changed:${settings.section_id}`, { detail: { index: idx } }));
            });

            splideInstance.mount();
            splideEl.splide = splideInstance;
          } catch(err) {
            console.warn('Splide mount error:', err);
          }
        },
        zoomGoTo(targetIndex) {
          const total = this.zoomTotalSlides();
          let idx = parseInt(targetIndex) || 1;
          if (idx < 1) idx = total;
          if (idx > total) idx = 1;
          this.zoomCurrentIndex = idx;

          const modalList = document.querySelector(`#ProductModal-${settings.section_id} .aamra-modal-list, #media-gallery-${settings.section_id} .splide__list`);
          if (modalList) {
            modalList.style.transform = `translate3d(-${(idx - 1) * 100}%, 0, 0)`;
            modalList.style.transition = 'transform 0.35s cubic-bezier(0.25, 1, 0.5, 1)';
          }

          document.dispatchEvent(new CustomEvent(`eurus:zoom-slide-changed:${settings.section_id}`, { detail: { index: idx } }));
          this.updateZoomCounter(idx);
          this.updateZoomThumbnail(idx);
        },
        zoomNext() {
          const total = this.zoomTotalSlides();
          let next = (this.zoomCurrentIndex || 1) + 1;
          if (next > total) next = 1;
          this.zoomGoTo(next);
        },
        zoomPrev() {
          const total = this.zoomTotalSlides();
          let prev = (this.zoomCurrentIndex || 1) - 1;
          if (prev < 1) prev = total;
          this.zoomGoTo(prev);
        },
        updateZoomCounter(idx) {
          const counterEl = document.querySelector(`#ProductModal-${settings.section_id} .zoom-gallery-counter`);
          if (counterEl) {
            const total = this.zoomTotalSlides();
            counterEl.textContent = `${idx}/${total}`;
          }
        },
        updateZoomThumbnail(idx) {
          const thumbsRoot = document.getElementById(`x-zoom-thumbnail-${settings.section_id}`);
          if (!thumbsRoot) return;
          const thumbs = thumbsRoot.querySelectorAll('.x-thumbnail');
          thumbs.forEach((th, i) => {
            if (i === (idx - 1)) {
              th.classList.remove('opacity-35', 'border-white/20');
              th.classList.add('border-2', 'border-white', 'opacity-100', 'ring-1', 'ring-white/50');
            } else {
              th.classList.add('opacity-35', 'border-white/20');
              th.classList.remove('border-2', 'border-white', 'opacity-100', 'ring-1', 'ring-white/50');
            }
          });
          if (thumbs[idx - 1]) {
            thumbs[idx - 1].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        },
        zoomOpen(position, isSplide) {
          this.zoomIsOpen = true;
          const initialIndex = parseInt(position) || 1;
          this.zoomCurrentIndex = initialIndex;
          this.showPinchHint = true;
          setTimeout(() => { this.showPinchHint = false; }, 2500);
          Alpine.store('xPopup').open = true;
          document.dispatchEvent(new CustomEvent('eurus:zoom:reset'));

          this.updateZoomCounter(initialIndex);
          this.updateZoomThumbnail(initialIndex);

          this.$nextTick(() => {
            this.zoomGoTo(initialIndex);
          });
          Alpine.store('xModal').activeElement = 'product-image-' + settings.section_id + '-' + position;
        },
        zoomClose() {
          this.zoomIsOpen = false;
          document.dispatchEvent(new CustomEvent('eurus:zoom:reset'));
          Alpine.store('xPopup').close();
        },
        
        videoHandleIntersect() {
          if (settings.video_autoplay) {
            Alpine.store('xVideo').play(this.$el);
          }
        },
        productModelInit() {
          window.Shopify.loadFeatures([
            {
              name: 'shopify-xr',
              version: '1.0',
              onLoad: this._productModelSetupShopifyXR,
            },
          ]);
        },
        _productModelSetupShopifyXR() {
          const setup = () => {
            document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
              window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
              modelJSON.remove();
            });
            window.ShopifyXR.setupXRElements();
          }
  
          if (!window.ShopifyXR) {
            document.addEventListener('shopify_xr_initialized', () => {
              setup();
            });
            return;
          }
      
          setup();
        },
        productModelLoadMedia() {
          let container = this.$el.parentNode;
          const content = document.createElement('div');
          content.appendChild(container.querySelector('template').content.firstElementChild.cloneNode(true));
  
          this.$el.classList.add('hidden');
          container.appendChild(content.querySelector('model-viewer'));
  
          this._productModelLoadViewerUI();
        },
        productModelPauseViewer() {
          if (this.$el.modelViewerUI) this.$el.modelViewerUI.pause();
        },
        _productModelLoadViewerUI() {
          window.Shopify.loadFeatures([
            {
              name: 'model-viewer-ui',
              version: '1.0',
              onLoad: this._productModelSetupViewerUI.bind(this),
            },
          ]);
        },
        _productModelSetupViewerUI(errors) {
          if (errors) return;
  
          this.$el.parentNode.modelViewerUI
            = new Shopify.ModelViewerUI(this.$el.parentNode.querySelector('model-viewer')); 
        }
      }));

      Alpine.data('xImageZoomPan', () => ({
        isZoomed: false,
        scale: 2.2,
        panX: 0,
        panY: 0,
        isDragging: false,
        startX: 0,
        startY: 0,
        hasMoved: false,
        init() {
          document.addEventListener('eurus:zoom:reset', () => this.reset());
          window.addEventListener('resize', () => { if (this.isZoomed) this.reset(); });
        },
        toggleZoom(e) {
          if (this.hasMoved) {
            this.hasMoved = false;
            return;
          }
          if (this.isZoomed) {
            this.reset();
          } else {
            this.isZoomed = true;
            this.panX = 0;
            this.panY = 0;
            if (e && e.currentTarget) {
              const rect = e.currentTarget.getBoundingClientRect();
              const clickX = (e.clientX || (e.touches && e.touches[0] && e.touches[0].clientX)) || (rect.left + rect.width / 2);
              const clickY = (e.clientY || (e.touches && e.touches[0] && e.touches[0].clientY)) || (rect.top + rect.height / 2);
              const offsetX = clickX - (rect.left + rect.width / 2);
              const offsetY = clickY - (rect.top + rect.height / 2);
              this.panX = Math.max(-200, Math.min(200, -offsetX * 0.8));
              this.panY = Math.max(-200, Math.min(200, -offsetY * 0.8));
            }
          }
        },
        reset() {
          this.isZoomed = false;
          this.panX = 0;
          this.panY = 0;
          this.isDragging = false;
          this.hasMoved = false;
        },
        startDrag(e) {
          if (!this.isZoomed) return;
          this.isDragging = true;
          this.hasMoved = false;
          const pageX = (e.touches && e.touches.length > 0) ? e.touches[0].pageX : e.pageX;
          const pageY = (e.touches && e.touches.length > 0) ? e.touches[0].pageY : e.pageY;
          this.startX = pageX - this.panX;
          this.startY = pageY - this.panY;
        },
        onDrag(e) {
          if (!this.isDragging || !this.isZoomed) return;
          const pageX = (e.touches && e.touches.length > 0) ? e.touches[0].pageX : e.pageX;
          const pageY = (e.touches && e.touches.length > 0) ? e.touches[0].pageY : e.pageY;
          const dx = Math.abs(pageX - (this.startX + this.panX));
          const dy = Math.abs(pageY - (this.startY + this.panY));
          if (dx > 4 || dy > 4) {
            this.hasMoved = true;
          }
          if (e.cancelable && e.type === 'touchmove') {
            e.preventDefault();
          }
          const x = pageX - this.startX;
          const y = pageY - this.startY;
          this.panX = Math.max(-400, Math.min(400, x));
          this.panY = Math.max(-400, Math.min(400, y));
        },
        endDrag() {
          this.isDragging = false;
        }
      }));
    });
  });
}